// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"71df1d4d","455":"95696d12","977":"41bae21f"}[chunkId] + ".chunk.js";
};